import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "error", "htmlFor", "gap", "label", "tooltip"];
import { useId, useState } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { cloneChildren } from '../cloneChildren';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { TooltipInfo } from '../Tooltip/TooltipInfo';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { LayoutSpaceVertical } from '../Layout/LayoutSpaceVertical';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InputWrapper = _ref => {
  let {
      children,
      disabled,
      error,
      htmlFor,
      gap = '0',
      label,
      tooltip
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const uniqueId = useId();
  const [inputId] = useState(htmlFor !== null && htmlFor !== void 0 ? htmlFor : `input-label-${uniqueId}`);
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, rest, spacingProps, {
    error: error,
    verticalSeparation: "flush",
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: gap,
      children: [label ? /*#__PURE__*/_jsx(FormLabel, {
        color: disabled ? 'text-core-disabled' : undefined,
        htmlFor: inputId,
        paddingBlockStart: "0",
        children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
          gap: "space-xs",
          children: [label, tooltip ? /*#__PURE__*/_jsx(TooltipInfo, {
            tooltip: tooltip
          }) : null]
        })
      }) : null, cloneChildren({
        children,
        newProps: {
          disabled,
          error,
          id: inputId
        }
      })]
    })
  }));
};
export const SelectWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
SelectWrapper.displayName = 'InputWrapper';